



























import { AccountOption } from "@/models/interface/cash-flow-report-mapping";
import { CashFlowMapping } from "@/models/interface/cash-flow-report-mapping/CashFlowMapping.interface.js";
import { Component, Prop, Vue } from "vue-property-decorator";
import CashFlowReportMappingRow from "./CashFlowReportMappingRow.vue";

@Component({
  components: {
    CashFlowReportMappingRow,
  },
})
export default class CashFlowReportMappingCard extends Vue {
  @Prop(String) title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly mappings!: CashFlowMapping[];

  @Prop({ type: Array, default: () => [] })
  readonly accountOptions!: AccountOption[];

  @Prop({ type: Number, default: null })
  readonly newlyAddedIndex!: number | null;

  SECTION_CONFIG = {
    OPERATING: {
      title: "lbl_cash_flow_from_operating_activities",
      icon: "file-sync",
    },
    INVESTING: {
      title: "lbl_cash_flow_from_investing_activities",
      icon: "rise",
    },
    FINANCING: {
      title: "lbl_cash_flow_from_financing_activities",
      icon: "wallet",
    },
  } as const;

  get sectionTitle(): string {
    return this.$t(this.SECTION_CONFIG[this.title]?.title || "") as string;
  }

  get sectionIcon(): string {
    return this.SECTION_CONFIG[this.title]?.icon || "";
  }
}
